export default __webpack_public_path__ + "3ceb50e7bcafb577367c21b53064e00c.woff2";